import Vuex from "vuex";
import Vue from 'vue/dist/vue.esm';
import {
  addProductToServerCart,
  removeProductFromServerCart,
  getCartDetails,
  createCart,
  updateQuantityOnServerCart,
} from './cartDataService';

Vue.use(Vuex);

function refreshCart(commit, dispatch, state) {
  getCartDetails(state.cartId, state.sellerPid, function(response) {
    commit('syncCart', response);
    if (response.status !== 'picking') {
      dispatch('orderComplete');
    }

    let buyerBoundToCart = state.boundBuyerId;
    if (buyerBoundToCart !== (state.buyerDetails.buyer_id || null)) {
      dispatch('orderComplete');
    }
  });
}

function addToCart(commit, cartId, sellerPid, order) {
  addProductToServerCart(cartId, sellerPid, { productId: order.productId, quantity: order.quantity }, function(response) {
    commit('syncCart', response);
    commit('setLastProduct', order);
  });
}


export default new Vuex.Store({
  state: {
    products: [],
    cartId: null,
    sellerPid: null,
    productsGrossPrice: '$0.00',
    productsGstPrice: '$0.00',
    deliveryGrossPrice: '$0.00',
    deliveryGstPrice: '$0.00',
    cartGrossPrice: '$0.00',
    shippingMethod: '$0.00',
    gstEnabled: false,
    lastProduct: {},
    buyerDetails: {},
    isBulky: false,
    status: null,
    boundBuyerId: null,
  },
  mutations:{
    setupCart(state, cartId) {
      state.cartId = cartId;
    },
    setBuyer(state, payload) {
      state.buyerDetails = payload;
    },
    setLastProduct(state, payload) {
      state.lastProduct = payload;
    },
    setSellerPid(state, pid) {
      state.sellerPid = pid;
    },
    resetCart(state) {
      state.cartId = null;
      state.products = [];
      state.productsGrossPrice = '$0.00';
      state.deliveryGrossPrice = '$0.00';
      state.cartGrossPrice = '$0.00';
      state.boundBuyerId= null;
    },
    syncCart(state, payload) {
      state.products = payload.products;
      state.productsGrossPrice = payload.productsGrossPrice;
      state.productsGstPrice = payload.productsGstPrice;
      state.deliveryGrossPrice = payload.deliveryGrossPrice;
      state.deliveryGstPrice = payload.deliveryGstPrice;
      state.cartGrossPrice = payload.cartGrossPrice;
      state.shippingMethod = payload.shippingMethod;
      state.gstEnabled = payload.gstEnabled;
      state.isBulky = payload.isBulky;
      state.status = payload.status;
      state.boundBuyerId = payload.boundBuyerId;
    },
  },
  getters: {
    cartTotal: state => {
      let total = 0;
      for (let i = 0; i < state.products.length; i++) {
        total += state.products[i].quantity;
      }

      return total;
    },
  },
  actions: {
    addProduct({commit, state}, order) {
      if (!state.cartId) {
        createCart(state.buyerDetails.buyer_id, state.sellerPid, function(newCartId) {
          commit('setupCart', newCartId);
          localStorage.setItem(`shopnet_cart_id_${state.sellerPid}`, newCartId);
          addToCart(commit, state.cartId, state.sellerPid, order);
        });
      } else {
        addToCart(commit, state.cartId, state.sellerPid, order);
      }
    },
    removeProduct({commit, state}, payload) {
      removeProductFromServerCart(state.cartId, payload.sellerPid, payload.productId, function(response) {
        commit('syncCart', response);
      });
    },
    updateProductQuantity({commit, state}, payload) {
      updateQuantityOnServerCart(state.cartId, payload.sellerPid, { productId: payload.id, quantity: payload.newQuantity }, function(response) {
        commit('syncCart', response);
      });
    },
    resumeCart({commit, state, dispatch}) {
      let existingCartId = localStorage.getItem(`shopnet_cart_id_${state.sellerPid}`) || localStorage.getItem('shopnet_cart_id') ;
      if(existingCartId === "null" || !existingCartId) {
        return;
      } else {
        commit('setupCart', existingCartId);
        dispatch('refreshCart');
      }
    },
    refreshCart({commit, state, dispatch}) {
      if (state.cartId) {
        refreshCart(commit, dispatch, state);
      }
    },
    setSeller({commit}, sellerPid) {
      commit('setSellerPid', sellerPid);
    },
    orderComplete({commit, state}) {
      commit('resetCart');
      localStorage.removeItem(`shopnet_cart_id_${state.sellerPid}`);
      localStorage.removeItem('shopnet_cart_id');
    },
  },
});

